import { IdTitle } from './id-title';

export const paymentStatuses: IdTitle[] = [
  {id: 1, title: 'Not Paid'},
  {id: 2, title: 'Deposit'},
  {id: 3, title: 'Fully Paid'},
  {id: 4, title: 'Overpaid'},
];
